import { useCallback, useEffect, useState } from "react";
import { fetchStorageStatus } from "@/features/infrastructure/api";

const statusColor = (s) =>
  s === "done"
    ? "text-green-600"
    : s === "failed"
      ? "text-red-600"
      : "text-amber-600";

export default function InfrastructurePage() {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setStatus(await fetchStorageStatus());
    } catch (e) {
      setError(String(e.message ?? e));
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, [load]);

  const jobs = status?.jobs ?? [];

  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold">Infrastructure — Storage</h1>
        <p className="text-sm text-gray-500">
          The weekly Postgres to ClickHouse migrations run so far.
        </p>
      </div>

      <div className="space-y-3 rounded-lg border p-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <div className="text-sm text-gray-500">Last migrated week</div>
            <div className="text-lg font-medium">
              {status?.lastMigratedWeek ?? "—"}
            </div>
          </div>
        </div>
        {error && <div className="text-sm text-red-600">{error}</div>}
      </div>

      <div className="overflow-hidden rounded-lg border">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left text-gray-500">
              <th className="p-3">Week</th>
              <th className="p-3">Tier</th>
              <th className="p-3">Status</th>
              <th className="p-3">Counts</th>
              <th className="p-3">Updated</th>
            </tr>
          </thead>
          <tbody>
            {jobs.length === 0 && (
              <tr>
                <td colSpan={5} className="p-3 text-gray-400">
                  No migrations yet.
                </td>
              </tr>
            )}
            {jobs.map((j) => (
              <tr key={j.uuid} className="border-b">
                <td className="p-3">{j.week}</td>
                <td className="p-3">
                  {j.fromTier} → {j.toTier}
                </td>
                <td className={`p-3 font-medium ${statusColor(j.status)}`}>
                  {j.status}
                </td>
                <td className="p-3">
                  {j.counts
                    ? Object.entries(j.counts)
                        .map(([k, v]) => `${k}: ${v}`)
                        .join("   ")
                    : (j.error ?? "—")}
                </td>
                <td className="p-3 text-gray-500">
                  {new Date(j.updatedAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
